import React, { useContext, useState, useEffect, useRef } from "react";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import MailOutlineRoundedIcon from "@material-ui/icons/MailOutlineRounded";
import StarRoundedIcon from "@material-ui/icons/StarRounded";
import MapComp from "../mapComponent/MapComp";
import CloudIcon from "@mui/icons-material/Cloud";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import MilestoneComp from "../milestoneComponent/MilestoneComp";
import ShipmentDetailsComp from "../ShipmentDetails/ShipmentDetailsComp";
import { HOST_URL, LOCAL_STORAGE_KEY } from "../../../../../config";
import { getUserData } from "../../../../common/utility/Utils";
import { StoreContext, StoreProvider } from "../../../../../store/Provider";
import Backdrop from "@material-ui/core/Backdrop";
import CircularProgress from "@material-ui/core/CircularProgress";
import { makeStyles } from "@material-ui/core/styles";
import MuiAlert from "@material-ui/lab/Alert";
import Snackbar from "@material-ui/core/Snackbar";
import Documents from "../Documents";
import "../shipmentbody.css";
import "./shipmentInfo.css";
import axios from "axios";
import Container from "../ShipmentDetails/Container";
import {
  IsShowShipmentContainer,
  IsShowShipmentDetail,
  IsShowShipmentDocument,
  IsShowShipmentList,
  IsShowShipmentMap,
  IsShowShipmentMilestone,
} from "../../../../../utils";
import ShipmentsCard from "../cardBody/ShipmentsCard";

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
}));

function ShipmentInfo() {
  const [value, setValue] = React.useState(0);
  const context = useContext(StoreContext);
  const [milestoneData, setMilestoneData] = useState({
    data: [],
    loading: false,
  });
  const [shipmentDetail, setShipmentDetail] = useState({
    data: {},
    loading: false,
  });
  const [containerData, setContainerData] = useState({
    data: [],
    loading: true,
  });
  const [starMarked, setStarMarked] = useState("");
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const [openalert, setOpenalert] = useState(false);
  const [alertText, setAlertText] = useState("");
  const [severity, setSeverity] = useState("error");
  const [mapData, setMapData] = useState([]);
  const [currentPin, setCurrentPin] = useState({});
  const [loading, setLoading] = useState("");
  const [shipments, setShipments] = useState([]);
  const [massData, setMassData] = useState(null);
  const [showAlert, setShowAlert] = useState(false);
  const [isActive, setIsActive] = useState(false);
  const buttonRef = useRef(null);

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenalert(false);
  };

  // console.log("mapData", mapData, currentPin);
  const { ShipmentPermisionCollection } = JSON.parse(
    localStorage.getItem("newTempData")
  );

  useEffect(() => {
    if (context.shipmentId !== "") {
      // context.setContainerShow(false);
      context.setTabValue(0);
      getMileStoneData();
      getShipmentsDetail();
      // getMapDetail();
      getContainerData();
    }
  }, [context.shipmentId]);

  useEffect(() => {
    setStarMarked("");
    if (shipmentDetail.data.IsMarked) {
      console.log(shipmentDetail.data.IsMarked);
      setStarMarked(shipmentDetail.data.IsMarked);
    }
  }, [shipmentDetail]);

  const getMileStoneData = async () => {
    let data = {};
    setMilestoneData({ data: [], loading: true });
    await getUserData(LOCAL_STORAGE_KEY.user_token)
      .then((res) => {
        data = res;
      })
      .catch((err) => {
        console.log(err);
      });

    const header = {
      Authorization: `Bearer ${data.access_token}`,
      UserName: data.user_name,
      UserSecret: data.password,
      DeviceType: "W",
      MacAddress: "",
      IPAddress: "",
    };
    //  Lune

    const END_POINT = `${HOST_URL}api/v2/ShipmentData/${data.user_country_code}/MilstoneRoute/${context.shipmentId}`;
    console.log("End Data", HOST_URL);
    axios
      .get(END_POINT, {
        headers: header,
      })
      .then((res) => {
        setMilestoneData({ data: res.data.Events, loading: false });
      })
      .catch((err) => {
        console.log(err);
        setMilestoneData({ data: [], loading: false });
      });
  };

  const getShipmentsDetail = async () => {
    let data = {};
    setLoading(true);
    setShipmentDetail({ data: {}, loading: true });
    await getUserData(LOCAL_STORAGE_KEY.user_token)
      .then((res) => {
        data = res;
      })
      .catch((err) => {
        console.log(err);
      });

    const header = {
      Authorization: `Bearer ${data.access_token}`,
      UserName: data.user_name,
      UserSecret: data.password,
      DeviceType: "W",
      MacAddress: "",
      IPAddress: "",
    };
    console.log("UserEmail:", data.user_name);
    console.log("Shipment ISD", context.shipmentId);
    console.log("Host Url", HOST_URL);
    const END_POINT = `${HOST_URL}api/v2/ShipmentData/${data.user_country_code}/Details/${context.shipmentId}`;
    axios
      .get(END_POINT, {
        headers: header,
      })
      .then((res) => {
        setShipmentDetail({ data: res.data, loading: false });
        console.log("ShipmentData", shipmentDetail);
        getMapDetail(res?.data?.MasterBillNumber, res?.data?.SCACCode);
      })
      .catch((err) => {
        console.log(err);
        setShipmentDetail({ data: {}, loading: false });
      });
  };

  // const getMapDetail = async (mblNum, scacCode) => {
  //   let data = {};
  //   setMapData({ data: [], loading: true });
  //   await getUserData(LOCAL_STORAGE_KEY.user_token)
  //     .then((res) => {
  //       data = res;
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     });

  //   const header = {
  //     Authorization: `Bearer ${data.access_token}`,
  //     UserName: data.user_name,
  //     UserSecret: data.password,
  //     DeviceType: "W",
  //     MacAddress: "",
  //     IPAddress: "",
  //   };

  //   // api/v1/Location/ShipmentGeoCoordinates/S2015163
  //   const END_POINT = `${HOST_URL}api/v1/Location/ShipmentGeoCoordinates/${context.shipmentId}`;
  //   const END_POINT_2 = `${HOST_URL}api/v1/Location/Tracking/getroutebasedonmbl?mblNumber=${mblNum}&sealine=${scacCode}&api_key=&type=BL`;
  //   axios
  //     .get(END_POINT, {
  //       headers: header,
  //     })
  //     .then((res) => {
  //       setMapData({ data: res.data.locations, loading: false });
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //       setMapData({ data: [], loading: false });
  //     });
  // };

  const getMapDetail = async (mblNum, scacCode) => {
    let data = {};
    await getUserData(LOCAL_STORAGE_KEY.user_token)
      .then((res) => {
        data = res;
      })
      .catch((err) => {
        console.log(err);
      });

    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${HOST_URL}api/v1/Location/Tracking/getroutebasedonmbl?mblNumber=${mblNum}&sealine=${scacCode}&api_key=&type=BL`,
      headers: {
        Authorization: `Bearer ${data.access_token}`,
        UserName: data.user_name,
        UserSecret: data.password,
        DeviceType: "W",
        MacAddress: "",
        IPAddress: "",
      },
    };

    axios
      .request(config)
      .then((res) => {
        console.log("res", res);
        setMapData(res.data.data.route ?? []);
        setCurrentPin({ lat: res.data.data.pin[0], lng: res.data.data.pin[1] });
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  const getContainerData = async () => {
    let data = {};
    await getUserData(LOCAL_STORAGE_KEY.user_token)
      .then((res) => {
        data = res;
      })
      .catch((err) => {
        console.log(err);
      });

    const header = {
      Authorization: `Bearer ${data.access_token}`,
      UserName: data.user_name,
      UserSecret: data.password,
      DeviceType: "W",
      MacAddress: "",
      IPAddress: "",
    };

    const END_POINT = `${HOST_URL}api/v2/ShipmentData/${context.shipmentId}/Containers`;
    axios
      .get(END_POINT, {
        headers: header,
      })
      .then((res) => {
        setContainerData({ data: res.data, loading: false });
      })
      .catch((err) => {
        console.log(err);
        setContainerData({ data: [], loading: false });
      });
  };

  const handleChange = (event, newValue) => {
    context.setTabValue(newValue);
  };

  if (context.shipmentId === "") {
    return (
      <div className="noShipmentsSelected">
        {context.rightHomeTitle ? "Select shipment to view Details." : ""}
      </div>
    );
  }

  const bookMarkShipment = async () => {
    setOpen(true);
    let data = {};
    await getUserData(LOCAL_STORAGE_KEY.user_token)
      .then((res) => {
        data = res;
      })
      .catch((err) => {
        console.log(err);
      });
    const header = {
      Authorization: `Bearer ${data.access_token}`,
      UserName: data.user_name,
      UserSecret: data.password,
      DeviceType: "W",
      MacAddress: "",
      IPAddress: "",
    };
    const params = new URLSearchParams();
    params.append("UserId", data.user_name);
    params.append("EntityId", context.shipmentId);
    params.append("DeviceId", "");
    const END_POINT = `${HOST_URL}api/v1/MarkedData/Shipment`;
    axios
      .post(END_POINT, params, {
        headers: header,
      })
      .then((res) => {
        setOpen(false);
        console.log(res.data.IsMarked);
        setStarMarked(res.data.IsMarked);
      })
      .catch((err) => {
        console.log(err);
        setOpen(false);
        setOpenalert(true);
        setSeverity("error");
        setAlertText("Something went wrong!");
      });
  };

  function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  }

  const handleluneClick = async () => {
    setIsActive(true);
    try {
      const data = await getUserData(LOCAL_STORAGE_KEY.user_token);
      const url = `${HOST_URL}api/v2/carbonemission/Calculate/lune/${
        context.shipmentId
      }?UserName=${encodeURIComponent(data.user_name)}`;

      const config = {
        method: "get",
        maxBodyLength: Infinity,
        url: url,
        headers: {
          Authorization: `Bearer ${data.access_token}`,
          UserName: data.user_name,
          UserSecret: data.password,
          DeviceType: "W",
          MacAddress: "",
          IPAddress: "",
        },
      };

      const response = await axios.request(config);
      const mass = response.data.result.mass;

      if (mass) {
        console.log("Mass1", mass);
        setMassData(mass);
        context.setMassData(mass);
      } else {
        setMassData(null);
      }

      setShowAlert(true);

      if (buttonRef.current) {
        buttonRef.current.focus(); // Focus the button
      }
    } catch (error) {
      console.error(error);
    } finally {
      setTimeout(() => {
        setIsActive(false);
        setShowAlert(false);
        setMassData(null);
      }, 3000);
    }
  };

  const handleCloseAlert = () => {
    setShowAlert(false);
  };

  const renderMassData = (amount, unit) => {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
        }}
      >
        <span style={{ fontSize: "14px", fontWeight: "600" }}>
          {amount} {unit}
        </span>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            marginLeft: "5px",
          }}
        >
          <img
            src={`${process.env.PUBLIC_URL}/Assets/Images/leaf_16.png`}
            alt="leaf"
          />
          <span
            style={{
              fontSize: "8px",
              fontWeight: "600",
              margin: 0,
              padding: 0,
              marginTop: -2,
            }}
          >
            CO<sub>2</sub>
          </span>
        </div>
      </div>
    );
  };

  return (
    <>
      <div
        className={
          IsShowShipmentList()
            ? "shipmentdetailsupper"
            : "shipmentdetailsupper_new"
        }
      >
        <Backdrop className={classes.backdrop} open={open}>
          <CircularProgress color="inherit" />
        </Backdrop>
        <Snackbar
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
          open={openalert}
          autoHideDuration={3000}
          onClose={handleClose}
        >
          <Alert severity={severity} onClose={handleClose}>
            {alertText}
          </Alert>
        </Snackbar>
        <div className="shipmentDetailsUpperTabHeader">
          <div className="shipmentDetailsUpperTabHeaderParent">
            <Tabs
              value={context.tabValue}
              onChange={handleChange}
              className="shipmentDetailsUpperTabParent"
            >
              <Tab
                label="Map"
                {...a11yProps(0)}
                className="shipmentDetailsTab"
                style={IsShowShipmentMap() ? {} : { display: "none" }}
                // disabled={!ShipmentPermisionCollection?.ShipmentMap}
              />
              <Tab
                label="Milestones"
                {...a11yProps(1)}
                className="shipmentDetailsTab"
                style={IsShowShipmentMilestone() ? {} : { display: "none" }}
                // disabled={!ShipmentPermisionCollection?.ShipmentMilstone}
              />
              <Tab
                label="Details"
                {...a11yProps(2)}
                className="shipmentDetailsTab"
                style={IsShowShipmentDetail() ? {} : { display: "none" }}
                // disabled={!ShipmentPermisionCollection?.ShipmentDetail}
              />
              {context.containerShow ? (
                <Tab
                  label="Container"
                  {...a11yProps(2)}
                  className="shipmentDetailsTab"
                  style={IsShowShipmentContainer() ? {} : { display: "none" }}
                />
              ) : null}
            </Tabs>
          </div>

          <div className="shipmentDetailsMailStar">
            <span
              className="pointer mailround mailed"
              onClick={() => {
                context.setModalType("contact");
                context.handleModalOpen();
              }}
            >
              <MailOutlineRoundedIcon />
            </span>
            <span
              className={
                starMarked
                  ? "pointer bookamark bookamarked"
                  : "pointer bookamark"
              }
              onClick={() => bookMarkShipment()}
            >
              <StarRoundedIcon />
            </span>
            <span style={{ color: "green" }}>
              <button
                ref={buttonRef}
                onClick={() => handleluneClick()}
                className="cloud-btn"
                style={{ backgroundColor: isActive ? "#147ad6" : " #147ad61a" }}
                disabled={isActive}
              >
                <img
                  src={
                    isActive
                      ? `${process.env.PUBLIC_URL}/Assets/Images/co22.png`
                      : `${process.env.PUBLIC_URL}/Assets/Images/co21.png`
                  }
                  alt="Example"
                  style={{
                    marginLeft: "5px",
                    width: "32px",
                    height: "32px",
                    background: "none",
                  }}
                />
              </button>
            </span>

            {showAlert && (
              <MuiAlert
                severity="info"
                className="massalert"
                action={
                  <IconButton
                    aria-label="close"
                    color="inherit"
                    size="small"
                    onClick={handleCloseAlert}
                  >
                    <CloseIcon fontSize="inherit" />
                  </IconButton>
                }
              >
                <div style={{ display: "flex", alignItems: "center" }}>
                  {massData ? (
                    renderMassData(massData.amount, massData.unit)
                  ) : (
                    <span style={{ fontSize: "14px;", fontWeight: "600" }}>
                      No Data!
                    </span>
                  )}
                </div>
              </MuiAlert>
            )}
          </div>
        </div>
        <div className="shipmentDetailsatbsbody">
          <TabPanel
            style={IsShowShipmentMap() ? {} : { display: "none" }}
            value={context.tabValue}
            className="tabshipmentDetails mapcompParent"
            index={0}
          >
            <div
              style={{ position: "relative", width: "100%", height: "100%" }}
            >
              {loading ? (
                <div
                  className="d-flex align-items-center justify-content-center"
                  style={{ height: "100%" }}
                >
                  <CircularProgress size="1.5rem" />
                </div>
              ) : (
                <MapComp
                  mapData={mapData}
                  currentPin={currentPin}
                  loading={loading}
                />
              )}
            </div>
          </TabPanel>
          <TabPanel
            style={IsShowShipmentMilestone() ? {} : { display: "none" }}
            value={context.tabValue}
            className="tabshipmentDetails"
            index={1}
            dis
          >
            <MilestoneComp milestoneData={milestoneData} />
          </TabPanel>
          <TabPanel
            style={IsShowShipmentDetail() ? {} : { display: "none" }}
            value={context.tabValue}
            className="tabshipmentDetails"
            index={2}
          >
            <ShipmentDetailsComp detail={shipmentDetail} />
          </TabPanel>
          <TabPanel
            value={context.tabValue}
            className="tabshipmentDetails"
            index={3}
          >
            <Container containerData={containerData} />
          </TabPanel>
        </div>
      </div>
      {IsShowShipmentDocument() ? <Documents /> : null}
    </>
  );
}

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div hidden={value !== index} id={`simple-tabpanel-${index}`} {...other}>
      {value === index && <>{children}</>}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default ShipmentInfo;
